import { type CourtSyncThemeMode, COURTSYNC_THEME_COOKIE_NAME } from '@court-sync/shared';

export type ThemeMode = CourtSyncThemeMode;

/** Must match inline script in index.html (pre-hydration theme). */
export const THEME_STORAGE_KEY = 'theme-storage';

/** Cookie name for landing ↔ web app theme sync; must match index.html and @court-sync/shared. */
export { COURTSYNC_THEME_COOKIE_NAME };

/** Pure: which `light`/`dark` class should be on `document.documentElement`. */
export function resolveDocumentThemeClass(theme: ThemeMode, prefersDark: boolean): 'light' | 'dark' {
  if (theme === 'system') {
    return prefersDark ? 'dark' : 'light';
  }
  return theme;
}

export function applyThemeClassToHtml(root: HTMLElement, theme: ThemeMode, prefersDark: boolean): void {
  const resolved = resolveDocumentThemeClass(theme, prefersDark);
  root.classList.remove('light', 'dark');
  root.classList.add(resolved);
}
